import React, {useContext, useState} from "react";
import { GlobalUser } from "../types/common.types";
import PassengerService from "../services/passenger.service";
import { PassengerContextType } from "../types/passenger";

const PassengerProvider = React.createContext<PassengerContextType>(null as any)

export const PassengerContext = ({children}: {children: React.ReactNode}) => {
    const getUser = () => {
        const user = localStorage.getItem('passenger')
        if (user) {
            return JSON.parse(user)
        } else return null
    }

    const getInstructionsGiven = () => {
        const instructions = localStorage.getItem('instructionsGiven')
        if (instructions) {
            return JSON.parse(instructions)
        } else return false
    }
    // useStates
    const [user, setUser] = useState<GlobalUser>(getUser())
    const [instructionsGiven, setInstructionsGiven] = useState<boolean>(getInstructionsGiven())
    
    // add token to class object
    user?.token && PassengerService.setToken(user.token)

    const values = {
        user, setUser,
        instructionsGiven, setInstructionsGiven
    }
    return <PassengerProvider.Provider value={values}>{children}</PassengerProvider.Provider>;
}

export const usePassenger = () => {
    return useContext(PassengerProvider)
}